$(document).on('turbolinks:load',function() {
  //表ボタンのテキストの変更＿表示・非表示
  $('.el_sw_table').on('click', function () {
    $(this).toggleClass('open');
  });

  //グラフボタンのテキストの変更＿表示・非表示
  $('.el_sw_graph').on('click', function () {
    $(this).toggleClass('open');
  });

  //表ボタン押下で、表エリアの表示・非表示
  $('.el_sw_table').on('click', function () {
    $('.table_area').toggle("");
  });

  //グラフボタン押下で、グラフエリアの表示・非表示
  $('.el_sw_graph').on('click', function () {
    $('.graph_area').toggle("");
  });
});